module.exports = __webpack_public_path__ + "static/img/02.212a10e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/02.jpg
// module id = upi5
// module chunks = 0